export const LookupKeys = {
    sessionIdKey: 'anid',
    SiteMembershipCtxPrefKey: 'org_ctx_pref',
    orgIdSessionKey: 'shop-membership-id',
    orgCtxTypeKey: 'shop-org-ctx-type',
    themeCookiePfx: 'theme-name',
    globalStripeObjName: '__SK_STRIPE_OBJ__',
    qsEntitySwitch: 'entity-switch',
    qsEntitySwitchNull: 'NULL'
} as const;

export const LookupHeaders = {
    sessionIdHeader: 'X-SK-Session-ID',
    siteIdHeader: 'X-SK-Site-ID',
    siteContextHeader: 'X-SK-Site-Context',
    siteVersionHeader: 'X-SK-Site-Version',
    orgIdHeader: 'X-SK-Shop-Membership-ID'
} as const;
